import type { ReactNode } from 'react';

export const symbol_settings_brightness: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m426-338 43 44q4.64 5 10.82 5 6.18 0 11.18-5l44-44h79q6 0 10.5-4.5T629-353v-81l38.92-38.92Q673-478 673-484.18T668-495l-39-38v-80q0-6-4.5-10.5T614-628h-80l-43-43q-4.64-5-10.82-5-6.18 0-11.18 5l-43 43h-77q-6 0-10.5 4.5T334-613v80l-38.92 38.92Q290-489 290-482.82t5 10.82l39 39v80q0 6 4.5 10.5T349-338h77Zm54-25v-238q49 0 83.5 34.71T598-482q0 49.58-34.42 84.29Q529.17-363 480-363ZM140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm0-60h680v-520H140v520Zm0 0v-520 520Z"
		/>
	</svg>
);
